<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

    <nav class="sdev-sidebar-nav">

        <Section v-for="section in visibleNav" :key="section.key" :section="section" :collapsed="collapsed" />

    </nav>

</template>

<script setup>

import Section from "@/framework/navigation/Section/Section.vue"
import { useNavigationUI } from '@/framework/bootstrap/useNavigationUI'

const props = defineProps({
    collapsed: Boolean
})

const { visibleNav } = useNavigationUI()

</script>